import Vue from 'vue'
import Vuex from 'vuex'
import { STORE_MODULES } from '@/enums'
import { storeModuleOrder, storeModuleToasts } from './modules'

Vue.use(Vuex)

export const store = new Vuex.Store({
    modules: {
        [STORE_MODULES.ORDER]: storeModuleOrder,
        [STORE_MODULES.TOASTS]: storeModuleToasts,
    },
})
